<template>
  <div
    v-if="startContent && announcementContent"
    class="subheader app-subheader"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <!-- begin::Announcement -->
    <div class="app-subheader__announcement">
      <marquee
        class="text-danger marque-loop"
        ref="announcementshow"
        :loop="loopTotal"
      >
        <span v-html="announcementContent"></span>
      </marquee>
    </div>
    <!--end::Announcement-->
  </div>
</template>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover { text-decoration: none; }
    &.dropdown-toggle-no-caret { &:after { content: none; } }
  }
  &.dropdown-menu {
    margin: 0; padding: 0; outline: none;
    .b-dropdown-text { padding: 0; }
  }
}
</style>

<style scoped>
.app-subheader {
  min-height: 32px;
  padding: 0 !important;
  background: #ffffff !important;
  border-top: 0 !important;
  border-bottom: 1px solid #E7EDF4;
  box-shadow: none !important;
}

.app-subheader__inner {
  min-height: 56px;
  width: 100%;
}

.app-subheader__heading {
  min-width: 0;
  gap: 16px;
}

.app-subheader__announcement {
  width: 100%;
  min-height: 32px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

/* ── Items & separator ──────────────────────────────── */
.bc-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.bc-sep {
  display: inline-flex;
  align-items: center;
  color: #94A3B8;
  margin: 0 6px;
  line-height: 1;
  user-select: none;
}

/* ── Folder icon ────────────────────────────────────── */
.bc-folder-icon {
  color: #1E958F;
  flex-shrink: 0;
}

/* ── Links ──────────────────────────────────────────── */
.bc-link {
  font-size: 0.8rem;
  font-weight: 600;
  color: #14608F;
  text-decoration: none;
  transition: color 0.15s ease;
  white-space: nowrap;
}
.bc-link:hover {
  color: #143263;
  text-decoration: none;
}

/* Home icon link */
.bc-home {
  color: #1E958F;
  display: inline-flex;
  align-items: center;
  transition: color 0.15s ease;
}
.bc-home:hover { color: #14608F; }

/* ── Active / current item ──────────────────────────── */
.bc-current {
  font-size: 0.8rem;
  font-weight: 700;
  color: #143263;
  white-space: nowrap;
}

@media (max-width: 767.98px) {
  .app-subheader__heading {
    width: 100%;
    gap: 10px;
    overflow: hidden;
  }

  .page-title {
    padding-right: 10px;
  }

  .breadcrumb-card {
    overflow: hidden;
  }

  .bc-current,
  .bc-link {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import module from "@/core/modules/CrudModule.js";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  data() {
    return {
      announcements: [],
      loopTotal: 3,
      announcementContent: "",
      startContent: false,
    };
  },
  methods: {
    async getAnnouncementActive() {
      // Reset first so an announcement that has just become inactive does not
      // leave stale running text (or an empty spacer) on the dashboard.
      this.announcements = [];
      this.announcementContent = "";
      this.startContent = false;

      let response = await module.paginate("announcements/get-shows");

      this.announcements = response && Array.isArray(response.data)
        ? response.data.filter(
            item =>
              item &&
              typeof item.content_running_text === "string" &&
              item.content_running_text.trim() !== ""
          )
        : [];

      for (let a = 0; a < this.announcements.length; a++) {
        this.announcementContent += `<i class="fas fa-bullhorn fa-sm text-primary"></i> ${this.announcements[a].content_running_text}  `;
      }

      this.startContent = this.announcements.length > 0;

      if (this.startContent) {
        this.$nextTick(() => {
          if (this.$refs.announcementshow) {
            this.$refs.announcementshow.loop = this.loopTotal;
          }
        });
      }
    },

    handleAnnouncementsUpdated() {
      this.getAnnouncementActive();
    },
  },
  mounted() {
    this.getAnnouncementActive();
    this.$root.$on("updateAnnouncements", this.handleAnnouncementsUpdated);
  },
  beforeDestroy() {
    this.$root.$off("updateAnnouncements", this.handleAnnouncementsUpdated);
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    },
  },
};
</script>
